// @ts-nocheck
import React, {useContext} from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import ScrollToTopButton from "../topbutton/Top";
import StyleContext from "../../contexts/StyleContext";
import {meta, overall} from "./data/fifaData";
import HeadlineWinRate from "./charts/HeadlineWinRate";
import RankGapWinRate from "./charts/RankGapWinRate";
import ThresholdSweep from "./charts/ThresholdSweep";
import GroupVsKnockout from "./charts/GroupVsKnockout";
import WinRateByTournament from "./charts/WinRateByTournament";
import SemifinalistAlignment from "./charts/SemifinalistAlignment";
import BiggestUpsets from "./charts/BiggestUpsets";
import "./FifaAnalysis.scss";

const SOURCE_REPO_URL = "https://github.com/bniroula/fifa-analysis";

// Page shell for the FIFA analysis dashboard: shared Header/Footer/scroll-to-top
// chrome, the headline hero, and the chart grid.
const FifaAnalysis = () => {
  const {isDark} = useContext(StyleContext);

  return (
    <div className={isDark ? "dark-mode fifa-analysis" : "fifa-analysis"}>
      <Header />

      <main className="fifa-analysis__content">
        <header className="fifa-analysis__hero">
          <p className="fifa-analysis__eyebrow">Data Analysis</p>
          <h1 className="fifa-analysis__title">
            FIFA Ranking vs. World Cup Outcomes
          </h1>
          <p className="fifa-analysis__lead">
            How well do pre-tournament FIFA rankings actually predict World Cup
            match outcomes, and at what point does a ranking gap stop carrying
            signal?
          </p>

          <a
            className="fifa-analysis__source"
            href={SOURCE_REPO_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            View data source &amp; methodology on GitHub →
          </a>

          <ul className="fifa-analysis__stats" aria-label="Headline statistics">
            <li className="fifa-analysis__stat">
              <span className="fifa-analysis__stat-value">
                {overall.winRate}%
              </span>
              <span className="fifa-analysis__stat-label">
                Higher-ranked team win rate
              </span>
            </li>
            <li className="fifa-analysis__stat">
              <span className="fifa-analysis__stat-value">
                {overall.ceiling}%
              </span>
              <span className="fifa-analysis__stat-label">
                Ceiling (draws count as a loss)
              </span>
            </li>
            <li className="fifa-analysis__stat">
              <span className="fifa-analysis__stat-value">
                {meta.matches}
              </span>
              <span className="fifa-analysis__stat-label">
                World Cup matches analysed
              </span>
            </li>
          </ul>
        </header>

        <section
          className="fifa-analysis__dashboard"
          aria-label="FIFA ranking analysis dashboard"
        >
          <div className="fifa-analysis__grid">
            {/* Charts are appended here in the handoff's narrative order. */}
            <HeadlineWinRate />
            <RankGapWinRate />
            <ThresholdSweep />
            <GroupVsKnockout />
            <WinRateByTournament />
            <SemifinalistAlignment />
            <BiggestUpsets />
          </div>
        </section>

        <p className="fifa-analysis__footnote">
          Scope: {meta.scope}. The strategy always backs the higher-ranked team
          (lower FIFA rank number); draws count as a loss, so the maximum
          achievable win rate is the {overall.ceiling}% ceiling, not 100%.{" "}
          Data sourcing and transformation:{" "}
          <a
            className="fifa-analysis__footnote-link"
            href={SOURCE_REPO_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub repository
          </a>
          .
        </p>
      </main>

      <Footer />
      <ScrollToTopButton />
    </div>
  );
};

export default FifaAnalysis;
